export class GcpCloudSqlRestoreDestination {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gcpCloudSql",
            "baseName": "gcpCloudSql",
            "type": "GcpCloudSqlTarget",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpCloudSqlRestoreDestination.attributeTypeMap;
    }
    constructor() {
    }
}
